'use client';

function unproxify(values) {
    if (values instanceof Date)
        return values;
    if (typeof window !== 'undefined' && values instanceof File)
        return values;
    if (values instanceof Array)
        return values.map(unproxify);
    if (values instanceof Object)
        return Object.fromEntries(Object.entries(Object.assign({}, values)).map(function (_a) {
            var key = _a[0], value = _a[1];
            return [key, unproxify(value)];
        }));
    return values;
}

export { unproxify as default };
//# sourceMappingURL=unproxify.js.map
